var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"data-test-id":_vm.$testId('button.policy'),"target":"_blank"}},'router-link',_vm.routeProps,false),[_vm._t("default",[_vm._v(_vm._s(_vm.$t('_common:terms.travelExperiencesPolicy')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }